import { Widget } from "../../components/widget/Widget"
import { Navbar } from "../../components/navbar/Navbar"
import { Sidebar } from "../../components/sidebar/Sidebar"
import "./home.scss"
import { Featured } from "../../components/featured/Featured"
import { FeaturedViva } from "../../components/featuredViva/FeaturedViva"
import { Chart } from "../../components/chart/Chart"
import CustomizedTables from "../../components/table/CustomizedTables"
import NewUpdates from "../../components/newupdates/NewUpdates"
import { Box, Typography } from '@mui/material';
export const Home = () => {
  return (
    <div className="home">
      <Sidebar />
      <div className="homeContainer">
        <Navbar />
       {/*}  <div className="widgets">
          <Widget type="student" />
          <Widget type="instructor" />
          <Widget type="course" />
          <Widget type="thesis" />
        </div> */}
        <div className="charts">
          <Featured />
           <div className="listContainer">
            <div className="listTitle">
             {/* Current Semester Courses */}
             </div>
            {/*<CustomizedTables />*/}
            <FeaturedViva />
          </div>
        </div>

        <div className="updates">
        <Box className="box">
      <Typography variant="h5"  sx={{
              
              fontSize: '17px',
              color: 'gray',
              
            }} gutterBottom>
        Previous Batches {/*Latest Updates*/}
      </Typography>
     <NewUpdates /> 
    </Box>
        
        </div>
        

        
      </div>
    </div>
  )
}


export default Home
